import { render, staticRenderFns } from "./HumanSilhouetteFront.vue?vue&type=template&id=65bdadc1&"
import script from "./HumanSilhouetteFront.vue?vue&type=script&lang=js&"
export * from "./HumanSilhouetteFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports